import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

import colors from "vuetify/lib/util/colors"

Vue.use(Vuetify);

// Translation provided by Vuetify (typescript)
import sv from '@/locale/sv'
import en from '@/locale/en'

export default new Vuetify({
    lang: {
        locales: { sv, en },
        current: 'sv',
    },
    theme: {
        // dark: true,
        themes: {
            light: {
                primary: colors.blue.darken4,
                accent: colors.blue,
                secondary: colors.lime,
                success: colors.lightGreen,
                error: colors.deepOrange.darken3,
                warning: colors.amber,
                info: colors.blueGrey
            },
            dark: {
                primary: colors.indigo
            }
        }
    }
});
